import { render, staticRenderFns } from "./AppStep.vue?vue&type=template&id=04e809d0&"
import script from "./AppStep.vue?vue&type=script&lang=js&"
export * from "./AppStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports